import MyCollapse from "../../components/MyCollapse";

const KCDH02 = () => {
  const content = [
    {
      value: 1,
      title: "K-CDH 참여 기관 자격",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text cdh2-1">
            <dl>
              <dt>01</dt>
              <dd>
                <h3>목표 환자수: 연간 35명 이상, 3년간 100명 이상</h3>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h3>
                  지난 5년간 연 평균 3명 이상 CDH 진료와 수술 경험이 있고 ECMO
                  시행이 가능한 신생아중환자실이 있는 병원
                </h3>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "K-CDH 참여 기관과 연구책임자",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text cdh2-1">
            <dl>
              <dd>
                <div className="box_wrap">
                  <div className="box">
                    <a
                      href="https://www.amc.seoul.kr/asan/main.do"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="/assets/img/cd3-3.png" alt="" />
                      <p>
                        신생아과 <b>이병섭</b> 선생님
                      </p>
                    </a>
                  </div>
                  <div className="box">
                    <a
                      href="https://www.severance.healthcare/severance/index.do"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="/assets/img/cd3-4.png" alt="" />
                      <p>
                        소아청소년과 <b>은호선</b> 선생님
                      </p>
                    </a>
                  </div>
                  <div className="box">
                    <a
                      href="https://www.snuh.org/intro.do"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="/assets/img/cd3-5.png" alt="" />
                      <p>
                        소아청소년과 <b>신승한</b> 선생님
                      </p>
                    </a>
                  </div>
                  <div className="box">
                    <a
                      href="https://www.samsunghospital.com/home/main/index.do"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="/assets/img/cd3-6.png" alt="" />
                      <p>
                        소아청소년과 <b>안소윤</b> 선생님
                      </p>
                    </a>
                  </div>
                  <div className="box">
                    <a
                      href="https://www.pnuyh.or.kr/pnuyh/intro.do"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="/assets/img/cd3-7.png" alt="" />
                      <p>
                        소아청소년과 <b>변신연</b> 선생님
                      </p>
                    </a>
                  </div>
                  <div className="box">
                    <a
                      href="https://www.cnuh.com/intro.cs"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="/assets/img/cd3-8.png" alt="" />
                      <p>
                        소아청소년과 <b>송은송</b> 선생님
                      </p>
                    </a>
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco cdh">
      <MyCollapse data={content} />
    </div>
  );
};

export default KCDH02;
